export default class SieauParameterDto {
    constructor(obj) {
        this.parameter = obj.parameter
        this.value = obj.value
        this.module = 'SIEAU'

        this.isChanged = obj.isChanged || false
    }
}